.hoverWrap {
  background: var(--paletteWhite0);
  min-width: 400px;
}

.hoverTitle {
  height: 40px;
  background-color: var(--paletteBlue2);
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  white-space: nowrap;
  text-overflow: ellipsis;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--paletteWhite0);

    h4 {
      flex: 1;
      margin: 0;
      font-size: var(--fontSizeRegular);
    }

    span {
      margin-left: 5px;
    }
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--paletteWhite0);

    p {
      flex: 0 1;
      margin: 0;
      color: var(--paletteWhite0);
      font-size: var(--fontSizeLabel);
    }

    .icon {
      margin-left: 2.5px;
      margin-right: 6px;
    }
  }
}

.hoverContent {
  padding: var(--spacingMd);
  color: var(--paletteWhite0);
}

.experienceLabel {
  max-width: 200px;
}
